import { useState } from "react";
import { IoMdClose } from "react-icons/io";

const PhaseStatusSelector = ({
  project,
  statusOptions,
  handleProjectScopeChange,
  hasPermission,
  stageRef,
  contentFrom,
}) => {
  // Convert stored phase_scopes to an array of status IDs
  const [selectedStatuses, setSelectedStatuses] = useState(
    typeof project.phase_scopes === "string"
      ? project.phase_scopes
          .split(",") // Convert string to array
          .map((statusName) => statusName.trim()) // Trim spaces
          .map(
            (statusName) => statusOptions.find((s) => s.name === statusName)?.id
          )
          .filter(Boolean) // Remove null values
      : []
  );

  // Compute available statuses (Exclude already selected ones)
  const availableStatuses = statusOptions.filter(
    (s) => !selectedStatuses.includes(s.id)
  );

  // Handle selecting a status
  const handleSelect = (statusId) => {
    const updatedStatuses = [...selectedStatuses, statusId];
    setSelectedStatuses(updatedStatuses);

    if (contentFrom === "phasedetails") {
      handleProjectScopeChange(project.phase_id, updatedStatuses);
    } else {
      handleProjectScopeChange(project.id, updatedStatuses);
    }
  };

  // Handle removing a status
  const handleRemove = (statusId) => {
    const updatedStatuses = selectedStatuses.filter((id) => id !== statusId);
    setSelectedStatuses(updatedStatuses);

    if (contentFrom === "phasedetails") {
      handleProjectScopeChange(project.phase_id, updatedStatuses);
    } else {
      handleProjectScopeChange(project.id, updatedStatuses);
    }
  };

  return (
    <td
      key={`phasestatus-${project.id}`}
      style={{ padding: "0px", border: "0px" }}
      ref={stageRef}
    >
      <div
        className="status-container"
        style={{ backgroundColor: "transparent" }}
      >
        {/* Selected Statuses */}
        <div
          className="selected-statuses"
          style={{ backgroundColor: "transparent" }}
        >
          {selectedStatuses.map((statusId) => {
            const statusObj = statusOptions.find((s) => s.id === statusId);
            return (
              <div
                key={statusId}
                className="status-item selected"
                style={{
                  backgroundColor: statusObj?.color || "white",
                }}
              >
                {statusObj?.name}
                <button
                  onClick={() => handleRemove(statusId)}
                  style={{ backgroundColor: "transparent", border: "none" }}
                  disabled={!hasPermission("projects", "update")}
                >
                  <IoMdClose
                    style={{
                      backgroundColor: "transparent",
                      color: "white",
                      fontSize: "13px",
                      marginTop: "5px",
                      cursor: "pointer",
                    }}
                  />
                </button>
              </div>
            );
          })}
        </div>

        {/* Available Statuses */}
        <div
          className="available-statuses"
          style={{ backgroundColor: "transparent", marginTop: "10px" }}
        >
          {availableStatuses.map((status) => (
            <div
              key={status.id}
              className="status-item available"
              style={{
                backgroundColor: status.color || "white",
                padding: "5px 3px",
                marginTop: "5px",
              }}
            >
              <button
                onClick={() => handleSelect(status.id)}
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  color: "white",
                  fontFamily: "Lato, sans-serif",
                  fontSize: "12px",
                  cursor: "pointer",
                }}
                disabled={!hasPermission("projects", "update")}
              >
                {status.name}
              </button>
            </div>
          ))}
        </div>
      </div>
    </td>
  );
};

export default PhaseStatusSelector;
